// The MIT License (MIT)
//
// Copyright (c) 2016-2024 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './sass/iframe.scss';
//import 'gmf/controllers/iframe_api.scss';
import 'gmf/controllers/iframe_api.scss';

import angular from 'angular';
import gmfControllersAbstractAPIController, {
  AbstractAPIController,
} from 'gmf/controllers/AbstractAPIController.js';
import nyonBase from '../nyonmodule.js';

/**
 * @private
 */
class Controller extends AbstractAPIController {
  /**
   * @param {angular.IScope} $scope Scope.
   * @param {angular.auto.IInjectorService} $injector Main injector.
   */
  constructor($scope, $injector) {
    super($scope, $injector);

    // Get full entry point
    const pathname = location.pathname;
    const pathnameSplit = pathname.split('/');
    const tag = pathnameSplit[1];
    const urlDomain = location.hostname;
    const substring = pathname.substring(0, 6);

    if (substring == '/theme' || substring == '/' || substring == '/ifram') {
      this.url = 'https://' + urlDomain;
    } else {
      this.url = 'https://' + urlDomain + '/' + tag;
    }

    const path = this.ngeoLocation.getUriString();
    const urlThemeSplit = path.split('/');
    const paramUrl = urlThemeSplit[urlThemeSplit.length - 1];
    const permalink = this.url + '/theme/' + paramUrl;

    this.openPermalink = () => {
      window.open(permalink);
    };
  }
}

/**
 * @hidden
 */
const nyonModule = angular.module('Appiframe', [nyonBase.name, gmfControllersAbstractAPIController.name]);

nyonModule.controller('IframeAPIController', Controller);

export default nyonModule;
